
























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Datetime } from './vue-datetime-time-out'
import 'vue-datetime/dist/vue-datetime.css'
import { Settings, DateTime } from 'luxon'

@Component({components: {Datetime}})
export default class TimeoutWings extends Vue {
  @Prop() value!: number|null;

  created(){
    Settings.defaultLocale = this.$i18n.locale;
  }

  get valueSelf(){
    if (!this.value) return '00:00:00';
    return DateTime.local().set({hour:0,minute:0,second:0}).plus({second:this.value}).toISO() ?? ''
  }

  set valueSelf(value:string){
    if (!value) {
      this.$emit('input',null);
      return;
    }
    let dateValue = DateTime.fromISO(value);
    let sendValue = dateValue.hour * 60 * 60 + dateValue.minute * 60 + dateValue.second;
    this.$emit('input',sendValue)
  }
}
